import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  master_aif_national_code: {
    name: 'Master aif national code'
  },
  domicile: {
    name: 'Domicile'
  },
  aif_name: {
    name: 'Fund Name'
  }
};

export function MasterAIF({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.MASTER_AIF,
    onChangeFund,
    schema: schema.MASTER_AIF,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.MASTER_AIF?.field_names || [],
    tableName: 'MASTER_AIF',
    order: 41 as any,
    columnLables,
    isMultiFunds,
    funds,
    onAddColumn,
    onDeleteColumn
  });

  return (
    <Table
      id="fca-reporttables-master-aif-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
